



















































































import _ from 'lodash';
import numeral from 'numeral';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {Http} from '@/decorators';
import {httpService, i18nService} from '@/services';
import {AxiosResponse} from 'axios';

import {CONFIG} from '@/config';
import {REPORT_GET_REPORTS} from '@/modules/neodash/store/modules/report/types';
import ReportLegend from '@/modules/neodash/components/report-legend/report-legend.vue';
import {PRINT_GET_PRINT_MODE} from '@/store/modules/print/types';
import * as moment from 'moment';

@Component({
  components: {
    ReportLegend
  }
})
export default class RegistrationByBrand extends Vue {
  numeral = numeral;

  @Prop({required: true})
  public dataQuery: any;

  @Getter(REPORT_GET_REPORTS)
  reports: any;
  @Getter(PRINT_GET_PRINT_MODE)
  printMode: any;

  public yearsHead: number[];
  public monthInit: string;
  public monthLast: string;
  public tipoReport: string;
  public tituloLocalidade: string;
  public dateAtualDescription: string = `${i18nService.i18n('Common.ActualDate')}: ` + moment(new Date()).format('DD/MM/YYYY');

  public state: any = {
    dataSource: [],
    requestData: {},
    client: ''
  };

  @Watch('dataQuery')
  public requestData() {
    this.state.requestData = {
      TypeLocality: this.dataQuery.resolutionLevel.value[0],
      YearLast: this.dataQuery.ano.value,
      MonthInit: this.dataQuery.mes_inicial.value,
      MonthLast: this.dataQuery.mes_final.value,
      GeoCodigos: this.dataQuery.localidades.value,
      VirtualAreaType: this.dataQuery.virtualAreaType ? this.dataQuery.virtualAreaType.value[0] : 0,
      TypeLicensePlate: this.dataQuery.tipo_emplacamento.value
    };

    this.monthInit = this.dataQuery.mes_inicial.text.substring(0, 3);
    this.monthLast = this.dataQuery.mes_final.text.substring(0, 3);
    this.yearsHead = _.range(this.state.requestData.YearLast + 1 - 5, this.state.requestData.YearLast + 1);
    this.tipoReport =
        this.dataQuery.tipo_emplacamento.value === 1
            ? 'SALES'
            : this.dataQuery.tipo_emplacamento.value === 2
            ? 'DIRECT SALES'
            : 'TOTAL';
    this.tituloLocalidade =
        this.dataQuery.localidades.text.length === 1 ? this.dataQuery.localidades.text[0].toUpperCase() + ' -' : '';

    httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/gigdashfilters/getDSRegistrationByBrand`, this.state.requestData)
        .then((res: AxiosResponse) => {
          this.state.client = res.data ? res.data.nameClient : '';
          this.state.dataSource = _(res.data.registration)
              .groupBy((d: any) => d.nome_bandeira)
              .map((d: any) => {
                this.yearsHead
                    .filter((f: any) => !d.some((vl: any) => f === vl.ano) && f.nome_bandeira != '')
                    .forEach(value => {
                      d.push({nome_bandeira: d[0].nome_bandeira, ano: value, emplac_bnd: 0});
                    });
                return _.orderBy(d, 'ano');
              })
              .orderBy((d: any) => -d[d.length - 1].emplac_bnd)
              .value();

          if (this.state.dataSource.some((f: any) => f[0].nome_bandeira === 'OUTROS')) {
            var outros = this.state.dataSource.filter((f: any) => f[0].nome_bandeira === 'OUTROS')[0];
            _.remove(this.state.dataSource, function (n: any) {
              return n[0].nome_bandeira === 'OUTROS';
            });
            this.state.dataSource.push(outros);
          }
        });
  }

  public created() {
    this.requestData();
  }
}
